module.exports = __webpack_public_path__ + "static/img/logo-wxpay.4cc4c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/invoice-manage/logo-wxpay.png
// module id = sh+M
// module chunks = 4